// extracted by mini-css-extract-plugin
export default {"pageSizeSelect":"PageSizeSelect_pageSizeSelect__CprAM","select":"PageSizeSelect_select__VTy7K"};